import { TradableTransaction } from "./tradable_transaction";

export class IndexTransaction extends TradableTransaction {
	private rebalance_information: RebalanceInformation = new RebalanceInformation();

	public getRebalanceInformation(): RebalanceInformation {
		return this.rebalance_information;
	}

	public getDtType(): string {
		return "";
	}

	public getDestinationTag(): string {
		return "";
	}

	public get isStorageFee(): boolean {
		return false;
	}

	public getPurposeText(): string {
		return "";
	}

	public isExternal(): boolean {
		return false;
	}

	public getContactId(): string {
		return "";
	}

	public hasAction(cancel: boolean): boolean {
		return false;
	}

	public isCancelable(): boolean {
		return false;
	}

	public isOutgoing(): boolean {
		return this.getType() === "sell";
	}
}

export class RebalanceInformation {
	private added: number = 0;
	private removed: number = 0;
	private rebalanced: number = 0;

	public getAdded(): number {
		return this.added;
	}

	public getRemoved(): number {
		return this.removed;
	}

	public getRebalanced(): number {
		return this.rebalanced;
	}
}
